<ng-container *ngIf="!noAddressDataExist">
	<div
		class="flex-nowrap"
		[ngClass]="{
			'd-flex': showAsNewLines,
			'd-inline-flex': !showAsNewLines
		}"
	>
		<ng-container *ngTemplateOutlet="streetTpl"></ng-container>
		<ng-container *ngTemplateOutlet="houseNumberTpl"></ng-container>
	</div>

	<div
		class="flex-nowrap"
		[ngClass]="{
			'd-flex': showAsNewLines,
			'd-inline-flex': !showAsNewLines
		}"
	>
		<ng-container *ngTemplateOutlet="additionalDataTpl"></ng-container>
	</div>

	<div
		class="flex-nowrap"
		[ngClass]="{
			'd-flex': showAsNewLines,
			'd-inline-flex': !showAsNewLines
		}"
	>
		<ng-container *ngTemplateOutlet="postalTpl"></ng-container>
		<ng-container *ngTemplateOutlet="cityTpl"></ng-container>
	</div>

	<div
		class="flex-nowrap"
		[ngClass]="{
			'd-flex': showAsNewLines,
			'd-inline-flex': !showAsNewLines
		}"
	>
		<ng-container *ngTemplateOutlet="stateTpl"></ng-container>
		<ng-container *ngTemplateOutlet="countryTpl"></ng-container>
	</div>
</ng-container>

<ng-container *ngIf="noAddressDataExist && alternativeEmptyAddressTextOutput">
	<div class="">
		<small>{{ alternativeEmptyAddressTextOutput }}</small>
	</div>
</ng-container>

<!-- ######################### TEMPLATES ######################### -->
<!-- STREET -->
<ng-template #streetTpl>
	<small
		*ngIf="showStreet && address?.street"
		class=""
		[ngClass]="{
			'me-1': showHouseNumber && address?.houseNumber,
			'me-2': showHouseNumber && !address?.houseNumber || !showHouseNumber
		}"
	>{{ address?.street }}</small>
</ng-template>

<!-- HOUSE NUMBER -->
<ng-template #houseNumberTpl>
	<small *ngIf="showHouseNumber && address?.houseNumber" class="me-2">{{ address?.houseNumber }}</small>
</ng-template>

<!-- ADDITIONAL DATA -->
<ng-template #additionalDataTpl>
	<small *ngIf="showAdditionalData && address?.additionalData" class="me-2">{{ address?.additionalData}}</small>
</ng-template>

<!-- POSTAL -->
<ng-template #postalTpl>
	<small *ngIf="showPostalCode && address?.postalCode" class="text-nowrap me-2">{{ address?.postalCode }}</small>
</ng-template>

<!-- CITY -->
<ng-template #cityTpl>
	<ng-container *ngIf="mediaData?.device?.type === deviceTypeEnum.MOBILE">
		<small *ngIf="showCity && address?.city && address?.street" class="me-2">{{ address?.city }}</small>
	</ng-container>

	<ng-container *ngIf="mediaData?.device?.type !== deviceTypeEnum.MOBILE">
		<small *ngIf="showCity && address?.city && showFederalState" class="me-2">{{ address?.city }}</small>
		<small *ngIf="showCity && address?.city && !showFederalState && showCountry" class="me-2">{{ address?.city ? address.city + ', ' : '' }}</small>
	</ng-container>
</ng-template>

<!-- STATE -->
<ng-template #stateTpl>
	<small *ngIf="showFederalState && address?.state && showCountry"
				 class="me-2">{{ address?.state ? address.state + ', ' : '' }}
	</small>
	<small *ngIf="showFederalState && address?.state && !showCountry"
				 class="me-2">{{ address?.state ? address.state : '' }}
	</small>
</ng-template>

<!-- COUNTRY -->
<ng-template #countryTpl>
	<small *ngIf="showCountry && country && address?.city" class="">{{ country }}</small>
</ng-template>





